import { useLocation } from 'react-router-dom';
import { SETTINGS_NAV_GROUPS, type SettingsNavItem } from './nav-config';

/**
 * Resolve the active nav item by matching the trailing slug of the current pathname
 * against the known settings sections. The base path is irrelevant — we only care
 * about what comes after `<base>/`.
 */
export function useActiveNavItem(base: string): SettingsNavItem | undefined {
  const { pathname } = useLocation();
  const stripped = pathname.replace(base, '').replace(/^\//, '');
  const items = SETTINGS_NAV_GROUPS.flatMap((group) => group.items);
  return items.find((item) => stripped === item.slug || stripped.startsWith(`${item.slug}/`));
}
